import { render, staticRenderFns } from "./employer-notes.vue?vue&type=template&id=bccbca80"
import script from "./employer-notes.vue?vue&type=script&lang=js"
export * from "./employer-notes.vue?vue&type=script&lang=js"
import style0 from "./employer-notes.vue?vue&type=style&index=0&id=bccbca80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports